import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { Retry } from '@components/common';
import { TableWrapper } from './styled';
import SubscriberTable from './SubscriberTable';
import useFetchData from './useFetchData';
import {
  sessionReqBody,
  obfuscateIp,
  obfuscateLocation,
  customerType,
  sessionsLoading,
  sessionsResponse,
} from '../AISummary/atom';
import { useSetAtom } from 'jotai';

function Table() {
  const { isIdle, status, data, refetch } = useFetchData();
  const setSessionReqBody = useSetAtom(sessionReqBody);
  const setObfuscateIp = useSetAtom(obfuscateIp);
  const setObfuscateLocation = useSetAtom(obfuscateLocation);
  const setCustomerType = useSetAtom(customerType);
  const setSessionLoading = useSetAtom(sessionsLoading);
  const setSessionsResponse = useSetAtom(sessionsResponse);

  // Combine pages and show row data
  const rows: any[] = [];

  useEffect(() => {
    const response = data?.pages?.[0]?.data || {};
    setSessionReqBody(response.reqBody);
    setObfuscateIp(response.obfuscateIp);
    setObfuscateLocation(response.obfuscateLocation);
    setCustomerType(response.customerType);
    setSessionLoading(status === 'loading' || isIdle);
    setSessionsResponse(response);
  }, [
    data,
    setSessionReqBody,
    setObfuscateIp,
    setObfuscateLocation,
    setCustomerType,
    setSessionLoading,
    setSessionsResponse,
    status,
    isIdle,
  ]);

  if (data) {
    data.pages.forEach((page) => {
      const records: any[] = get(page, ['data', 'data'], []);
      rows.push(...records);
    });
  }

  return (
    <TableWrapper>
      <Retry
        isLoading={status === 'loading' || isIdle}
        showError={status === 'error'}
        isEmpty={isEmpty(rows)}
        mountChildAlways={false}
        fetchData={refetch}
      >
        <SubscriberTable sessionData={rows} />
      </Retry>
    </TableWrapper>
  );
}

export default React.memo(Table);
